const translations = {
    addField: 'Add Field'
};

export default translations;
